import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';

const NavigationNavbar = () => {
  return (
    <Navbar className="main-nav" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand className="main-nav__brand" href="#top">
          <img
            className="main-nav__logo"
            src={`${process.env.PUBLIC_URL}/moonwood_electrical_logo.png`}
            alt=""
          />
          <span>Moonwood Electrical</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="site-navigation" className="main-nav__toggle" />

        <Navbar.Collapse id="site-navigation">
          <Nav className="ms-auto main-nav__links">
            <Nav.Link href="#services">Services</Nav.Link>
            <Nav.Link href="#work">Recent Work</Nav.Link>
            <Nav.Link href="#areas">Areas Covered</Nav.Link>
            <Nav.Link href="#contact">Contact</Nav.Link>
          </Nav>
          <a className="site-button site-button--compact main-nav__cta" href="#contact">
            Request a quote
          </a>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationNavbar;
